import { useToast } from "@commonlibs";
import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApiV2 } from "../api/giftcardsApiV2";

export default function useDeleteGiftCardStock({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, number>): UseMutationResult<void, unknown, number> {
    const translate = useTranslate();
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    const handleOnSuccess = (data: void, variables: number, context: unknown) => {
        showToast(translate("giftCardDeletedSuccessfully"), { type: "success" });
        queryClient.invalidateQueries(Queries.GIFTCARDS_STOCK_FIND_ALL);
        onSuccess?.(data, variables, context);
    };

    return useMutation(
        async (id: number) => {
            await giftcardsApiV2.deleteGiftCardStock(id);
        },
        {
            onSuccess: handleOnSuccess,
            ...options,
        },
    );
}
